
// global constants
const diamondFeatureNamesMappings = {
  'Very Good': 'VG',
  Excellent: 'EX',
  Good: 'GD',
  Fair: 'F',
  Poor: 'P',
  Ideal: 'ID',
  None: 'NONE',
  'Very Slight': 'VSL',
  Faint: 'FNT',
  Medium: 'MED',
  Strong: 'STG',
  'Very Strong': 'VST',
};

async function fetchDiamondsFromNivode(parametersForFilter) {
  const payload = {
    method: 'POST',
    body: JSON.stringify(parametersForFilter),
    headers: {
      'Content-Type': 'application/json',
    },
  };
  let nivodaFeedURL = 'https://fergusjames.com/apps/diamond-proxy/api/v2/feed';

  const response = await fetch(nivodaFeedURL, payload);
  const responseBody = await response.json();

  console.log('🥱 Nivoda Diamonds', responseBody);
  return responseBody;
}

async function fetchOneDiamondFromNivode(diamondID) {
  try {
    const res = await fetch(`https://fergusjames.com/apps/diamond-proxy/api/v2/feed/${diamondID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const resp = await res.json();
    if (resp?.id === diamondID) {
      return resp;
    } else {
      throw new Error('Diamond not found');
    }
  } catch (err) {
    console.error('Error fetching diamond:', err, diamondID);
    return { error: err instanceof Error ? err.message : 'Request error' };
  }
}

//

async function getNivodaDiamondsCount(parametersForFilter) {
  const payload = {
    method: 'POST',
    body: JSON.stringify(parametersForFilter),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  let nivodaCountURL = 'https://fergusjames.com/apps/diamond-proxy/api/count';
  const response = await fetch(nivodaCountURL, payload);
  const responseBody = await response.json();

  console.log('🥱 Nivoda Diamonds Count', responseBody);
  return responseBody;
}

//
function getFilterParamsFromURL(params, page = 1) {
  const originalShapes = [
    'ROUND',
    'PRINCESS',
    'CUSHION BRILLIANT',
    'CUSHION MODIFIED',
    'CUSHION',
    'OVAL',
    'PEAR',
    'EMERALD',
    'HEART',
    'RADIANT',
    'MARQUISE',
    'SQUARE EMERALD',
  ];

  let filterParams = {
    callFrom: 'feed',
    query: {
      labgrown: true,
      labgrown_type: [],
      shapes: [originalShapes[0]],
      certificate_lab: params.get('certification')?.split(',') || ['GIA', 'IGI'],
      color: params.get('color')?.split(',') || ['K', 'J', 'I', 'H', 'G', 'F', 'E', 'D'],
      returns: true,
      sizes: {
        from: parseFloat(params.get('carat_min')) || 1.0,
        to: parseFloat(params.get('carat_max')) || 21,
      },
      clarity: params.get('clarity')?.split(',') || ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'],
      cut: params.get('cut')?.split(',') || ['ID', 'EX', 'GD', 'VG'],
      polish: params.get('polish')?.split(',') || ['P', 'F', 'GD', 'VG', 'EX'],
      symmetry: params.get('symmetry')?.split(',') || ['P', 'F', 'GD', 'VG', 'EX', 'ID'],
      flouresence: params.get('fluorescence')?.split(',') || ['NON', 'VSL', 'FNT', 'MED', 'STG'],
    },
    offset: (page - 1) * 20,
    order: {
      type: 'price',
      direction: 'ASC',
    },
  };

  const sortDiamondsVal = params.get('sort_diamonds');
  if (sortDiamondsVal) {
    const [type, dir] = sortDiamondsVal.split('-');
    filterParams.order.type = type;
    filterParams.order.direction = dir;
  }

  // lab -  1.00ct D-F VS2-IF Lab grown diamond
  filterParams.query.color = params.get('color')?.split(',') || ['F', 'E', 'D'];
  filterParams.query.clarity = params.get('clarity')?.split(',') || ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2'];
  filterParams.query.cut = params.get('cut')?.split(',') || ['ID', 'EX'];

  if (params.get('diamond_type') === 'natural') {
    // nat    1.00ct D-H Si2-IF
    filterParams.query.color = params.get('color')?.split(',') || ['H', 'G', 'F', 'E', 'D'];
    filterParams.query.clarity = params.get('clarity')?.split(',') || [
      'FL',
      'IF',
      'VVS1',
      'VVS2',
      'VS1',
      'VS2',
      'SI1',
      'SI2',
    ];
    filterParams.query.certificate_lab = params.get('certification')?.split(',') || ['GIA'];

    filterParams.query.labgrown = false;
    delete filterParams.query.labgrown_type;
  }

  const diamondShape = params.get('diamond_shape');
  if (diamondShape) {
    if (diamondShape === 'CUSHION') {
      filterParams.query.shapes = [originalShapes[2], originalShapes[3], originalShapes[4]];
    } else if (diamondShape === 'EMERALD') {
      filterParams.query.shapes = [originalShapes[7], originalShapes[11]];
    } else {
      filterParams.query.shapes = [diamondShape];
    }
  }

  if (params.get('budget_min') || params.get('budget_max')) {
    const budgetMin = parseInt(params.get('budget_min')) || 0;
    const budgetMax = parseInt(params.get('budget_max')) || 1000000;

    // The budget slider's raw value is denominated in whatever currency the
    // customer currently has selected (persisted in localStorage), so it
    // must be converted from that currency - not a hardcoded one.
    const myStoredCurrency = localStorage.getItem('myCurrency');
    const supportedCurrencies = Object.keys(currencySymbolMap);
    const myCurrency = supportedCurrencies.includes(myStoredCurrency) ? myStoredCurrency : 'AED';

    // Convert the raw value from the customer's selected currency back to
    // AED first, then forth from AED to USD using our AED/USD exchange rate.
    const budgetMinInAED = budgetMin ? (budgetMin * exchangeRates[myCurrency]) / exchangeRates.AED : 0;
    const budgetMaxInAED = (budgetMax * exchangeRates[myCurrency]) / exchangeRates.AED;

    const budgetMinInUSD = budgetMin ? budgetMinInAED * exchangeRates.AED : 1;
    const budgetMaxInUSD = budgetMaxInAED * exchangeRates.AED;

    filterParams.query.dollar_value = {
      from: Math.round(budgetMinInUSD),
      to: Math.round(budgetMaxInUSD),
    };
  }

  const tableMin = parseInt(params.get('table_min')) || 0;
  const tableMax = parseInt(params.get('table_max')) || 100;
  if (tableMin && tableMax) {
    filterParams.query.table_percentage = {
      from: tableMin,
      to: tableMax,
    };
  }

  return filterParams;
}

function getSearchCertificateFilterParams(params) {
  let searchParams = {
    query: {
      certificate_numbers: params.get('cert_no')?.split(','),
      custom_query: false,
      is_user_supplier: false,
    },
    order: {
      type: 'size',
      direction: 'DESC',
    },
  };
  const sortDiamondsVal = params.get('sort_diamonds');
  if (sortDiamondsVal) {
    const [type, dir] = sortDiamondsVal.split('-');
    searchParams.order.type = type;
    searchParams.order.direction = dir;
  }
  return searchParams;
}

// Function to update diamond grid
async function updateDiamondGrid(newPage = false, page = 1) {
  const diamonds_section = document.getElementById('nivoda-grid');
  const urlSearchParams = new URLSearchParams(window.location.search);
  let filterParams = {};
  const clearSearchFilterContainer = document.querySelector('.clear-search-filter-container');
  if (urlSearchParams.get('cert_no')) {
    filterParams = getSearchCertificateFilterParams(urlSearchParams);
    newPage = false;
    currentDiapage = 1;
    page = 1;

    let searchCertUi = '';
    for (const cert of filterParams.query.certificate_numbers) {
      searchCertUi += `
          <div class="clear-search-filter">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0704 10.42L7.89892 8.24852M7.89892 8.24852C8.27036 7.87708 8.565 7.43611 8.76603 6.9508C8.96705 6.46548 9.07052 5.94533 9.07052 5.42002C9.07052 4.89472 8.96705 4.37457 8.76603 3.88925C8.56501 3.40394 8.27036 2.96297 7.89892 2.59152C7.52747 2.22008 7.0865 1.92544 6.60119 1.72441C6.11587 1.52339 5.59572 1.41992 5.07042 1.41992C4.54511 1.41992 4.02496 1.52339 3.53964 1.72441C3.05433 1.92544 2.61336 2.22008 2.24192 2.59152C1.49175 3.34169 1.07031 4.35913 1.07031 5.42002C1.07031 6.48092 1.49175 7.49836 2.24192 8.24852C2.99208 8.99869 4.00952 9.42013 5.07042 9.42013C6.13131 9.42013 7.14875 8.99869 7.89892 8.24852Z" stroke="#9E9E9E" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            ${cert}
            <button value="${cert}" onclick="clearSearchFilter(event)">
              <svg
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          `;
    }
    if (clearSearchFilterContainer) {
      clearSearchFilterContainer.innerHTML = searchCertUi;
      clearSearchFilterContainer.style.marginTop = '10px';
      clearSearchFilterContainer.style.marginBottom = '10px';
    }
  } else {
    filterParams = getFilterParamsFromURL(urlSearchParams, page);
    if (clearSearchFilterContainer) {
      clearSearchFilterContainer.innerHTML = '';
      clearSearchFilterContainer.style.marginTop = '0';
      clearSearchFilterContainer.style.marginBottom = '0';
    }
  }
  updateDiamondsCountLabel(filterParams);

  // Show loading state
  if (!newPage) {
    diamonds_section.querySelectorAll('.diamond-card').forEach((card) => {
      card.classList.add('loading');
      card.querySelector('.diamond-image-container').classList.add('skeleton');
      card.querySelector('.diamond-info').classList.add('skeleton');
    });
  }

  localStorage.removeItem('ringDiamondProductSelected');
  let isSuccessful = false;

  try {
    const diamonds = await fetchDiamondsFromNivode(filterParams);

    if (diamonds.length === 0) {
      throw new Error('No diamonds found');
    }

    if (diamonds.length > 0) {
      if (newPage) {
        const savedDiamonds = JSON.parse(localStorage.getItem('ringDiamondProducts'));
        const newDiamonds = [...savedDiamonds, ...diamonds];
        localStorage.setItem('ringDiamondProducts', JSON.stringify(newDiamonds));
      } else {
        localStorage.setItem('ringDiamondProducts', JSON.stringify(diamonds));
      }
    }

    let currency = localStorage.getItem('myCurrency');
    if (!exchangeRates[currency]) {
      currency = 'AED';
    }
    const currencySymbol = currencySymbolMap[currency];

    let ui = '';
    for (const diamond of diamonds) {
      const calculatedPrice = Math.ceil(diamond.price / exchangeRates[currency]).toLocaleString();

      const cert = diamond.certificate;

      const descriptionValues = {};
      const descriptionToInclude = [
        'polish',
        'symmetry',
        'fluorescence',
        'measurements',
        'table',
        'depth',
        'certificate',
      ];

      diamond.description.match(/<li>(.*?)<\/li>/g)?.forEach((li) => {
        const [label, value] = li.replace(/<\/?li>/g, '').split(': ');
        if (descriptionToInclude.includes(label.toLowerCase())) {
          if (label === 'Measurements') {
            descriptionValues['Dimensions'] = value.replaceAll('x', ' x ');
          } else {
            descriptionValues[label] = value;
          }
        }
      });

      const diamondTitle = [
        cert.shape.charAt(0).toUpperCase() + cert.shape.slice(1).toLowerCase() || 'Round',
        (cert.carats || 1) + 'ct',
        cert.color || 'D',
        cert.clarity || 'ID',
        cert.shape === 'ROUND' ? cert.cut || 'ID' : '',
        diamondFeatureNamesMappings[descriptionValues.Polish || 'None'],
        diamondFeatureNamesMappings[descriptionValues.Symmetry || 'None'],
        diamondFeatureNamesMappings[descriptionValues.Fluorescence || 'None'],
      ].join(' ');

      const formattedDescription = Object.entries(descriptionValues)
        .map(
          ([label, value]) => `
              <div>
                <span>${label}</span>
                <span>${value}</span>
              </div>
            `
        )
        .join('');

      ui += `
        <div class="diamond-card" id="D${diamond.id}" 
        data-cert-type="${cert.lab}" 
        data-price="${diamond.price}" data-currency="${currency}" 
        data-diamond-title="${diamondTitle}" data-diamond-description="${diamond?.title}">
          <div class="diamond-image-container"
            onmouseenter="turnOn360View(event)"
            onclick="openDiamondLargeModalView(event)"
            onmouseleave="turnOff360View(event)"
          >
            <img src="${diamond.topImage}" alt="${diamond.title}" class="diamond-image" crossorigin="anonymous">
             <button class="diamond-view-button-camera-icon" onclick="openDiamondLargeModalView(event)">
              <img
              width="25"
              height="25"
              src="https://cdn.shopify.com/s/files/1/0842/8965/0991/t/11/assets/video_icon.svg?v=1714673953"
              >
            </button>
            <button class="diamond-rotate-360-button"
              data-v360-url="${diamond?.certificate?.v360?.url}"
              data-frame-count="${diamond?.certificate?.v360?.frame_count}"
              data-top-img="${diamond?.topImage}"
            >
            ${diamond?.certificate?.v360?.url
          ? `<img
                height="30"
                width="30"
                src="https://cdn.shopify.com/s/files/1/0842/8965/0991/files/360-button.svg?v=1739814474"
              >`
          : ''
        }
            </button>

            <button class="diamond-stop-rotate-360-button">
              <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"/>
              </svg>
            </button>

            <button class="diamond-more-info-button" onclick="toggleDiamondDescription(event)">
              <span>MORE</span>
            </button>
            ${diamond.title.includes('Lab Grown')
          ? `<span class="diamond-lab-grown-label">LAB</span>`
          : diamond.title.includes('Natural')
            ? `<span class="diamond-lab-grown-label" style="background-color: #B2E870">NATURAL</span>`
            : ''
        }
            <div class="diamond-description-container">
              ${formattedDescription}
            </div>
            <div class="diamond-360-container"></div>
          </div>

          <div class="diamond-info">
            <div class="diamond-id">
             <a><span>${cert.lab}: Certified</span></a>
            </div>
            <h2 class="diamond-title">${diamondTitle}</h2>
            <p class="diamond-price">
              ${currencySymbol + (currency == 'AED' ? ' ' : '') + calculatedPrice}
            </p>
          </div>
          
          <div class="button-container">
            <button class="check-discount-btn" onclick="openCheckDiscountModalView(event)">CHECK FOR DISCOUNT</button>
            <div class="select-diamond-btn-container">
              <button class="remove-diamond-btn" onclick="removeSelectedDiamond(event, '${diamond.id}')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="30" height="30">
                  <path d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"/>
                </svg>
              </button>
              <button onclick="addSelectedDiamond(event, '${diamond.id}')" class="select-diamond-btn">SELECT DIAMOND
              </button>
              <button onclick="GoToNextStep()" class="next-step-diamond-btn">NEXT STEP</button>
            </div>
          </div>
        </div>
      `;
    }

    if (newPage) {
      diamonds_section.innerHTML += ui;
    } else {
      diamonds_section.innerHTML = ui;
    }

    isSuccessful = true;

    updateDiamondsCertificateLabel(diamonds.map((diamond) => diamond.id));
    updateDiamondBackgroundColour();
  } catch (error) {
    console.error('Error fetching diamonds:', error);
    isSuccessful = false;
  }

  const loadMoreContainer = document.querySelector('.load-more-container');

  if (!isSuccessful) {
    if (!newPage) {
      diamonds_section.innerHTML = `
          <div class="no-results">
            <h3>No diamonds found</h3>
            <p>Try adjusting your filters to view results</p>
          </div>
        `;

      loadMoreContainer.innerHTML = ``;
    }
  } else {
    loadMoreContainer.innerHTML = `
        <button onclick="nextPage()" class="load-more-btn">Load More</button>
      `;
  }

  return isSuccessful;
}

async function updateDiamondsCountLabel(filterParamsQuery) {
  try {
    const resultsSection = document.querySelectorAll('.results-section');
    const resultsCount = document.querySelectorAll('.results-section .results-count');

    resultsSection.forEach((section) => {
      section.classList.add('loading');
    });

    const diamondsCount = await getNivodaDiamondsCount(filterParamsQuery);
    totalDiamondsFetched = diamondsCount?.data?.diamonds_by_query_count || 0;

    resultsCount.forEach((strong) => {
      if (filterParamsQuery.query.certificate_numbers) {
        strong.innerHTML = totalDiamondsFetched.toLocaleString();
      } else {
        strong.innerHTML =
          totalDiamondsFetched.toLocaleString() +
          ' ' +
          filterParamsQuery.query.shapes[0].charAt(0).toUpperCase() +
          filterParamsQuery.query.shapes[0].slice(1).toLowerCase();
      }
    });

    resultsSection.forEach((section) => {
      section.classList.remove('loading');
    });
  } catch (error) {
    console.error('Error fetching diamonds count:', error);
  }
}

async function updateDiamondsCertificateLabel() {
  try {
    const diamondCards = document.querySelectorAll('.diamond-card');
    diamondCards.forEach(async (diamondCard) => {
      try {
        const parsedID = diamondCard.id.split('D')[1];

        const resp = await fetchOneDiamondFromNivode(parsedID);
        if (!resp.error && resp.id) {
          const certMatch = resp.description?.match(/Certificate Number: ([A-Za-z0-9\s]+)/i);
          const certLinkMatch = resp.description?.match(/Certificate PDF: <a href="([^"]+)"/i);
          const isIgi = resp.certificate?.lab === 'IGI';
          const certno = certMatch ? certMatch[1].trim() : 'Certified';
          let certLinkUrl = certLinkMatch ? certLinkMatch[1] : null;
          if (isIgi && certno) {
            certLinkUrl = `https://api.igi.org/viewpdf.php?r=${certno}`;
          }
          if (parsedID === resp.id) {
            const certType = diamondCard.dataset.certType;
            if (!certno || !certLinkUrl) return;
            diamondCard.querySelector('.diamond-info .diamond-id').innerHTML = `<a ${certLinkUrl ? `href="${certLinkUrl}" target="_blank" rel="noopener noreferrer"` : ''
              }>
                <span>${certType}: <span style="text-decoration: underline;">${certno || 'Certified'}</span></span>
              </a>
              `;
          }
        }
      } catch (error) {
        console.error('Error setting certificates: for diamond', parsedID, error);
      }
    });
  } catch (error) {
    console.error('Error updating certificates:', error);
  }
}

function updateDiamondBackgroundColour(price) {
  const diamondCards = document.querySelectorAll('#nivoda-grid .diamond-card');
  diamondCards.forEach((diamondCard) => {
    const imgContainer = diamondCard.querySelector('.diamond-image-container');
    const img = imgContainer.querySelector('.diamond-image');
    setDiamondBackgroundColour(img.src, imgContainer, img);
  });
}

function setDiamondBackgroundColour(imageUrl, element, image = null) {
  try {
    const diamondBackgroundCanvas = document.getElementById('diamond-background-canvas');
    let img = image;
    if (!img) img = new Image();
    img.crossOrigin = 'Anonymous'; // Allow cross-origin images
    img.onload = () => {
      const ctx = diamondBackgroundCanvas.getContext('2d', { willReadFrequently: true });
      diamondBackgroundCanvas.width = img.width;
      diamondBackgroundCanvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pixelData = ctx.getImageData(0, 0, 1, 1).data;
      if (!pixelData[0] || !pixelData[1] || !pixelData[2]) return;
      element.style.backgroundColor = `rgb(${pixelData[0]}, ${pixelData[1]}, ${pixelData[2]})`;
    };
    if (!img || !img.src) img.src = imageUrl;
  } catch (error) {
    console.error('Error getting diamond background colour:', error);
  }
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  updateDiamondGrid();
});

function toggleDiamondDescription(e) {
  const button = e.target.closest('.diamond-more-info-button');
  if (!button) return;

  const diamondCard = button.closest('.diamond-card');
  const diamondDescriptionContainer = diamondCard.querySelector('.diamond-description-container');
  const diamondMoreInfoButton = diamondCard.querySelector('.diamond-more-info-button span');

  if (diamondDescriptionContainer) {
    diamondDescriptionContainer.classList.toggle('open');
    if (diamondMoreInfoButton) {
      diamondMoreInfoButton.innerHTML = diamondDescriptionContainer.classList.contains('open') ? 'LESS' : 'MORE';
    }
  }
}

let activeContainer = null;
let manuallyActivated = false;
let isInitializing360 = false;

async function turnOn360View(event) {
  if (isAnyViewerDragging || isInitializing360) return;
  if (event.type !== 'click' && manuallyActivated) return;

  const closeCard = event.target.closest('.diamond-card');
  const container = closeCard.querySelector('.diamond-360-container');

  if (!container || container?.classList.contains('active')) return;

  const rotateButton = closeCard.querySelector('.diamond-rotate-360-button');

  if (activeContainer) {
    if (activeContainer?.viewer) {
      activeContainer.viewer.destroy();
    }
    activeContainer.innerHTML = '';
    activeContainer.classList.remove('active');
    activeContainer = null;
  }

  if (!rotateButton) return;
  const baseUrl = rotateButton.dataset.v360Url;
  if (!baseUrl.includes('http')) return;

  isInitializing360 = true;

  if (event.type === 'click') {
    const diamondDescriptionContainer = closeCard.querySelector('.diamond-description-container');
    const diamondMoreInfoButton = closeCard.querySelector('.diamond-more-info-button span');
    if (diamondDescriptionContainer) diamondDescriptionContainer.classList.remove('open');
    if (diamondMoreInfoButton) diamondMoreInfoButton.innerHTML = 'MORE';
    manuallyActivated = true;
  }

  // clear existing container
  if (container?.viewer) {
    container.viewer.destroy();
  }

  container.innerHTML = '';
  container.classList.remove('active');

  const frameCount = parseInt(rotateButton.dataset.frameCount);
  const topImg = rotateButton.dataset.topImg;

  container.viewer = create360Viewer(container, baseUrl, frameCount, topImg);
  activeContainer = container;

  container.classList.add('active');

  isInitializing360 = false;
}

function turnOff360View(event) {
  if (event.type !== 'click' && manuallyActivated) return;
  // Wait for the 360 viewer to be initialized before closing
  if (isInitializing360 || isAnyViewerDragging) return;

  if (event.type === 'click') {
    manuallyActivated = false;
  }

  if (activeContainer) {
    if (activeContainer?.viewer) {
      activeContainer.viewer.destroy();
    }
    activeContainer.innerHTML = '';
    activeContainer.classList.remove('active');
    activeContainer = null;
  }

  const closeCard = event.target.closest('.diamond-card');
  const container = closeCard.querySelector('.diamond-360-container');
  if (!container) return;

  if (container?.viewer) {
    container.viewer.destroy();
  }

  container.classList.remove('active');
  container.innerHTML = '';
  activeContainer = null;
}

let currentDiapage = 1;
let isLoadingMore = false;

async function nextPage() {
  if (isLoadingMore) return; // Prevent multiple simultaneous calls
  isLoadingMore = true;
  document.querySelector('.load-more-container').innerHTML = `
        <img width="78" height="78" src="https://fergusjames.com/cdn/shop/t/38/assets/loader-dia.svg?v=25917440371860867031726217276">
      `;
  currentDiapage++;
  const isSuccess = await updateDiamondGrid(true, currentDiapage);
  if (!isSuccess) {
    currentDiapage--;
  }
  document.querySelector('.load-more-container').innerHTML = `
        <button onclick="nextPage()" class="load-more-btn">Load More</button>
      `;
  isLoadingMore = false;
}

function addSelectedDiamond(event, diamondID) {
  console.log('diamondID', diamondID);

  const savedDiamonds = JSON.parse(localStorage.getItem('ringDiamondProducts'));
  let diamond = savedDiamonds.find((dia) => dia.id === diamondID);

  const closestCard = event.target.closest('.diamond-card');
  const certNumber = closestCard.querySelector('.diamond-info .diamond-id a > span');

  if (!diamond) return;

  if (certNumber.textContent) {
    diamond = { certno: certNumber.textContent, ...diamond };
  }

  localStorage.setItem('ringDiamondProductSelected', JSON.stringify(diamond));

  const allDiamonds = document.querySelectorAll('.diamond-card');
  allDiamonds.forEach((diamondCard) => {
    const selectDiamondBtn = diamondCard.querySelector('.select-diamond-btn');
    if (selectDiamondBtn) {
      selectDiamondBtn.classList.remove('active');
    }
  });
  event.target.classList.add('active');
}

function removeSelectedDiamond(event, diamondID) {
  console.log('diamondID', diamondID);
  localStorage.removeItem('ringDiamondProductSelected');
  const button = event.target.closest('.select-diamond-btn-container').querySelector('.select-diamond-btn');
  if (button) {
    button.classList.remove('active');
  }
}

function openDiamondLargeModalView(event) {
  if (event.target.closest('.diamond-more-info-button') || justDragged) {
    return;
  }

  const diamondLargeModalView = document.querySelector('.diamond-large-modal-view');
  if (diamondLargeModalView.classList.contains('active')) return;

  const outerContainer = diamondLargeModalView.querySelector('.diamond-large-modal-view-container');
  const imageContainer = diamondLargeModalView.querySelector('.diamond-large-modal-view-image');
  const lmvCert = diamondLargeModalView.querySelector('.diamond-lmv-cert');
  const container = document.querySelector('.diamond-large-modal-view-content');

  const lmvOption360 = diamondLargeModalView.querySelector('.diamond-lmv-options-360');
  const lmvOptionImage = diamondLargeModalView.querySelector('.diamond-lmv-options-img');

  const closestCard = event.target.closest('.diamond-card');
  if (!closestCard) return;

  const button = closestCard.querySelector('.diamond-rotate-360-button');
  if (!button) return;

  const baseUrl = button.dataset.v360Url;
  const topImg = button.dataset.topImg;
  const frameCount = parseInt(button.dataset.frameCount);

  //kill other container
  if (activeContainer && activeContainer !== container) {
    if (activeContainer.viewer) {
      activeContainer.viewer.destroy();
    }
    activeContainer.innerHTML = '';
    activeContainer.classList.remove('active');
    activeContainer = null;
  }

  if (container.viewer) {
    container.viewer.destroy();
  }
  container.innerHTML = '';
  //

  const closestCardCertUrl = closestCard.querySelector('.diamond-id a');
  if (closestCardCertUrl.href) {
    lmvCert.href = closestCardCertUrl.href;
  }
  setDiamondBackgroundColour(topImg, outerContainer);

  if (!baseUrl.includes('http')) {
    lmvOption360.style.display = 'none';
    lmvOptionImage.style.display = 'block';
    imageContainer.style.display = 'block';
    imageContainer.src = topImg;
    container.style.display = 'none';
    lmvOptionImage.querySelector('img').src = topImg;
    lmvOption360.querySelector('img').src = '';
  } else {
    lmvOption360.style.display = 'block';
    lmvOptionImage.style.display = 'none';
    imageContainer.style.display = 'none';
    imageContainer.src = '';
    lmvOptionImage.querySelector('img').src = '';
    lmvOption360.querySelector('img').src = topImg;
    //
    container.style.display = 'block';
    container.viewer = create360Viewer(container, baseUrl, frameCount, topImg);
    manuallyActivated = true;
    activeContainer = container;
    //
  }

  diamondLargeModalView.style.display = 'flex';
  diamondLargeModalView.classList.add('active');
}

function closeDiamondLargeModalView(event) {
  const diamondLargeModalView = document.querySelector('.diamond-large-modal-view');
  const container = diamondLargeModalView.querySelector('.diamond-large-modal-view-content');
  const lmvCert = diamondLargeModalView.querySelector('.diamond-lmv-cert');
  const imageContainer = diamondLargeModalView.querySelector('.diamond-large-modal-view-image');
  const lmvOptionImage = document.querySelector('.diamond-lmv-options-img');
  const lmvOption360 = document.querySelector('.diamond-lmv-options-360');

  if (activeContainer) {
    if (activeContainer?.viewer) {
      activeContainer.viewer.destroy();
    }
    activeContainer.innerHTML = '';
    activeContainer.classList.remove('active');
    activeContainer = null;
  }

  if (container.viewer) {
    container.viewer.destroy();
  }
  container.innerHTML = '';

  activeContainer = null;
  manuallyActivated = false;

  lmvCert.href = '';
  imageContainer.style.display = 'none';
  container.style.display = 'block';

  lmvOptionImage.style.display = 'none';
  lmvOption360.style.display = 'block';

  diamondLargeModalView.style.display = 'none';
  diamondLargeModalView.classList.remove('active');
}

function handleDiamondLargeModalViewClick(event) {
  if (event.target == event.currentTarget) {
    closeDiamondLargeModalView(event);
  }
}

function openCheckDiscountModalView(event) {
  const checkDiscountModalView = document.querySelector('.check-discount-modal-view');
  const container = checkDiscountModalView.querySelector('.check-discount-modal-diamond');
  const viewerWrapper = checkDiscountModalView.querySelector('.check-discount-modal-diamond-viewer-wrapper');

  if (activeContainer && activeContainer !== container) {
    if (activeContainer.viewer) {
      activeContainer.viewer.destroy();
    }
    activeContainer.innerHTML = '';
    activeContainer.classList.remove('active');
    activeContainer = null;
  }

  if (container.viewer) {
    container.viewer.destroy();
  }
  container.innerHTML = '';

  const closestCard = event.target.closest('.diamond-card');
  const button = closestCard.querySelector('.diamond-rotate-360-button');

  if (!button) return;

  const baseUrl = button.dataset.v360Url;
  const frameCount = parseInt(button.dataset.frameCount);
  const topImg = button.dataset.topImg;

  const diamondTitle = closestCard.dataset.diamondTitle;
  const diamondTitleBox = checkDiscountModalView.querySelector('.diamond-info-title span');
  diamondTitleBox.textContent = diamondTitle;

  const diamondDiscountFormTextarea = checkDiscountModalView.querySelector('.diamond-discount-form-textarea');
  diamondDiscountFormTextarea.value = `Hi! I love the look of this diamond ${diamondTitle}. I'd like to challenge your team to get me a better price or find me a better quality diamond for the same price!`;

  const certNumber = closestCard.querySelector('.diamond-info .diamond-id a > span');
  if (certNumber.textContent) {
    const diamondProductDesc = certNumber.textContent + ' ' + closestCard.dataset.diamondDescription;
    const diamondDiscountFormProduct = checkDiscountModalView.querySelector('.diamond-discount-form-product');
    diamondDiscountFormProduct.value = diamondProductDesc;
  }

  container.viewer = create360Viewer(container, baseUrl, frameCount, topImg);
  manuallyActivated = true;
  activeContainer = container;

  setDiamondBackgroundColour(topImg, viewerWrapper);

  const certificationData = closestCard.querySelector('.diamond-info .diamond-id');
  const diamondGiaCertification = checkDiscountModalView.querySelector('.diamond-gia-certification');
  if (certificationData) diamondGiaCertification.innerHTML = certificationData.innerHTML;

  checkDiscountModalView.style.display = 'flex';
  checkDiscountModalView.style.opacity = '0';
  setTimeout(() => {
    checkDiscountModalView.style.opacity = '1';
  }, 10);

  checkDiscountModalView.classList.add('active');
}

function closeCheckDiscountModalView(event) {
  const checkDiscountModalView = document.querySelector('.check-discount-modal-view');
  const container = checkDiscountModalView.querySelector('.check-discount-modal-diamond');

  if (activeContainer) {
    if (activeContainer?.viewer) {
      activeContainer.viewer.destroy();
    }
    activeContainer.innerHTML = '';
    activeContainer.classList.remove('active');
    activeContainer = null;
  }

  if (container?.viewer) {
    container.viewer.destroy();
  }

  container.innerHTML = '';
  activeContainer = null;
  manuallyActivated = false;

  checkDiscountModalView.style.opacity = '0';
  setTimeout(() => {
    checkDiscountModalView.style.display = 'none';
  }, 100);

  checkDiscountModalView.classList.remove('active');
}

function handleCheckDiscountModalViewClick(event) {
  if (event.target == event.currentTarget) {
    closeCheckDiscountModalView(event);
  }
}

function clearSearchFilter(event) {
  const currentParams = new URLSearchParams(window.location.search);
  const currentCertNo = currentParams.get('cert_no');
  const currentCertNoArray = currentCertNo ? currentCertNo.split(',') : [];
  const filterCertNo = event.target.closest('.clear-search-filter').querySelector('button').value;
  console.log('filterCertNo', filterCertNo);
  console.log('currentCertNoArray', currentCertNoArray);
  console.log(
    'newCertNoArray',
    currentCertNoArray.filter((value) => value !== filterCertNo)
  );
  if (currentCertNoArray.length > 0) {
    const newCertNoArray = currentCertNoArray.filter((value) => value !== filterCertNo);
    if (newCertNoArray.length > 0) {
      createUrlFilterParams('cert_no', newCertNoArray.join(','));
      return;
    }
  }
  createUrlFilterParams('cert_no', '', false);
}
